import React, { Component } from 'react';
import { ProductionDemandReport, EquipmentDashboard, InventoryCycleCount } from "../components";

export default class Home extends Component {
  static displayName = Home.name;
  
  render() {
    return (
      <div className="ml-4 mr-4">
        {this.props.currentUser.isPlanner ? (
          <ProductionDemandReport />
        ) : (
              this.props.currentUser.isMaintenanceUser ? (
                <EquipmentDashboard />
            ) : (
                <InventoryCycleCount /> 
            )
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js